import { Fetch } from 'lib';
import type { PaymentGatewaySummary } from 'types';

type RequestResponses = {
  paymentGateways: PaymentGatewaySummary[];
};

const getPaymentGateways = async () =>
  await Fetch<RequestResponses>({
    url: 'adminPaymentGateway/getPaymentGateways',
  });

export { getPaymentGateways };
